import { environment } from '@bvl-admin/environments/environment';

export class SiteMenuEndpoint {
  public static getMenu = `${environment.LOAD_BALANCER}/menus/list`;
  public static addMenu = `${environment.LOAD_BALANCER}/menus/save`;
  public static updateMenu = `${environment.LOAD_BALANCER}/menus/update`;
  public static deleteMenu = `${environment.LOAD_BALANCER}/menus/delete`;
}
